package com.essntl.features.crm.data.supabase

import com.essntl.config.EssntlConfig
import com.essntl.features.crm.domain.model.OrganizationListModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class OrganizationListDto(
    val id: String,
    val name: String,
    val type: String,
    val website: String?,
    val headcount: Int,
    val contacts: List<ContactOrganizationDto>,
    val expanded: Boolean,
    @SerialName("logo_url")
    val logoUrl: String?,
) {
    fun toModel() =
        OrganizationListModel(
            id = id,
            name = name,
            type = type,
            website = website,
            headcount = headcount,
            expanded = expanded,
            contacts = contacts.map { it.toModel() },
            logoUrl = logoUrl?.let { url -> if (url.contains("http")) url else "${EssntlConfig.supabaseUrl}/${EssntlConfig.supabaseStorageUrl}/$url" },
        )
}